import { Answer, FLOW_TYPES, Question, QuestionsTypes, QuestionType } from '../../../Types'
import { AssignmentData } from '../../../hooks/useAssignment'
import { groupBy, keyBy, orderBy } from 'lodash'

export type WalkStep = { question: Question; answers: Answer[] }

export const BRANCHING_QUESTIONS: QuestionType[] = [QuestionsTypes.radio]

export const isBranching = (type: QuestionType) => BRANCHING_QUESTIONS.includes(type)

const nextQuestionId = (q: Question, latest: Answer | undefined): string | null => {
  // check if branching
  if (isBranching(q.type) && latest) {
    const idx = parseInt(latest.value, 10)
    return !Number.isNaN(idx) && q.next[idx] ? q.next[idx] : null
  }
  return q.next[0] ?? null
}

// Walk from the first question, following answered radio choices when present
// and next[0] otherwise. Stops at a dead end (no next) or a revisit.
const walkDependencyPath = (
  questions: Question[],
  grouped: Record<string, Answer[]>,
  startId: string | null
): Question[] => {
  const byId = keyBy(questions, '_id')
  const path: Question[] = []
  const visited = new Set<string>()
  let current: string | null = startId
  while (current && !visited.has(current)) {
    visited.add(current)
    const q = byId[current]
    if (!q) break
    path.push(q)
    current = nextQuestionId(q, grouped[current]?.[0])
  }
  return path
}

//
// the startid is only passed when its a dependency assignment
//
export const deriveCurrentWalk = (data: AssignmentData, startId: string | null): WalkStep[] => {
  //
  // Very important!!!
  // this sorts all answers by deviceTime and createdAt, latest first
  // This is assumes later on - when walking the dependency path
  //
  // Will be empty if no answers
  //
  const answersByQuestionId = groupBy(
    orderBy(data.answers, ['deviceTime', 'createdAt'], ['desc', 'desc']),
    'questionId'
  )

  // this way of checking should make sure that if a older questionniare is used it will fallback to a linear path
  if (data.flowType !== FLOW_TYPES.DEPENDENCY) {
    return data.questions.map((q: Question): WalkStep => {
      const answerArr = answersByQuestionId[q._id] ?? []
      return { question: q, answers: answerArr }
    })
  }

  return walkDependencyPath(data.questions, answersByQuestionId, startId).map((q: Question): WalkStep => {
    return { question: q, answers: answersByQuestionId[q._id] ?? [] }
  })
}
